"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNetworkState = exports.isNetworkActiveAsync = exports.isNetworkActive = exports.checkNetworkStatePeriodically = exports.checkNetworkState = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _config = _interopRequireWildcard(require("./config"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var WINDOW = (typeof self === "undefined" ? "undefined" : (0, _typeof2["default"])(self)) === 'object' && self.self === self && self || (typeof global === "undefined" ? "undefined" : (0, _typeof2["default"])(global)) === 'object' && global.global === global && global;
var networkState = WINDOW && WINDOW.navigator && WINDOW.navigator.onLine;
var updateNetworkState = exports.updateNetworkState = function updateNetworkState(state) {
  if (_config.isDevEnvironment) console.log('updateNetworkState', state);
  networkState = state;
};
var isNetworkActive = exports.isNetworkActive = function isNetworkActive() {
  if (_config.isDevEnvironment) console.log('isNetworkActive', networkState);
  return networkState || navigator.onLine;
};
if (WINDOW && WINDOW.addEventListener) {
  WINDOW.addEventListener('online', function () {
    return updateNetworkState(true);
  }, false);
  WINDOW.addEventListener('offline', function () {
    return updateNetworkState(false);
  }, false);
}
var checkNetworkState = exports.checkNetworkState = function checkNetworkState(url, callback) {
  _axios["default"].get(url, {
    timeout: 3000,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,OPTIONS'
    }
  }).then(function (response) {
    callback(true);
  })["catch"](function (error) {
    callback(false);
  });
};
var remoteResourceUrl = _config["default"].remoteResourceUrl || "https://jsonplaceholder.typicode.com/todos/1";
checkNetworkState(remoteResourceUrl, updateNetworkState);
var checkNetworkStatePeriodically = exports.checkNetworkStatePeriodically = function checkNetworkStatePeriodically() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60000;
  setInterval(function () {
    return checkNetworkState(remoteResourceUrl, updateNetworkState);
  }, interval);
};
var isNetworkActiveAsync = exports.isNetworkActiveAsync = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _t;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _t = networkState || navigator.onLine;
          if (_t) {
            _context.next = 2;
            break;
          }
          _context.next = 1;
          return _axios["default"].get(remoteResourceUrl, {
            timeout: 3000,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET,OPTIONS'
            }
          }).then(function () {
            return true;
          })["catch"](function () {
            return false;
          });
        case 1:
          _t = _context.sent;
        case 2:
          return _context.abrupt("return", _t);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isNetworkActiveAsync() {
    return _ref.apply(this, arguments);
  };
}();